import Cookies from "js-cookie";

import { TOAuthResponseTransformed } from "@lib/street-autocomplete/types";
import { reportError } from "@utils/errorReporting";

import { TOKEN_HERE_MAPS_COOKIE_NAME } from "../constants";

export const updateTokenCookie = (hereMapsTokenData: TOAuthResponseTransformed): void => {
  try {
    Cookies.set(TOKEN_HERE_MAPS_COOKIE_NAME, hereMapsTokenData.accessToken, {
      expires: new Date(Date.now() + hereMapsTokenData.expiresIn * 1000),
      sameSite: "strict",
    });
  } catch (err) {
    // Something is wrong with new authData.
    reportError(err, { module: "hereMaps" });
  }
};

export const getTokenCookie = (): string | null => {
  const dataStr = Cookies.get(TOKEN_HERE_MAPS_COOKIE_NAME);
  if (!dataStr) {
    return null;
  }
  try {
    return dataStr;
  } catch (err) {
    // Corrupted cookie
    return null;
  }
};

export const removeTokenCookie = (): void => {
  Cookies.remove(TOKEN_HERE_MAPS_COOKIE_NAME);
};
